import getDisplayError, { SERVER_ERROR_CODE } from './getDisplayError';
import ApiError from './errors/ApiError';
import { Logger } from '@vue-storefront/core';

interface AxiosError {
  isAxiosError: boolean;
  response: {
    status?: number;
    data?: {
      message?: string;
    };
  };
}

const getUnknownErrorStatusCode = (error: unknown) => (error as Response).status || 500;

const getAxiosStatusCode = (error: AxiosError) => {
  if (error.isAxiosError) {
    return error.response?.status || 500;
  }
};

const getUnknownErrorMessage = (error: unknown): string | undefined => {
  if (typeof error === 'string') {
    return error;
  }
  return (error as Error).message || (error as Response).statusText;
};

const getAxiosErrorMessage = (error: AxiosError) => {
  if (error.isAxiosError) {
    return error.response?.data?.message;
  }
};

const getStatusCode = (error: unknown) =>
  getAxiosStatusCode(error as AxiosError) || getUnknownErrorStatusCode(error);

const getErrorMessage = (error: unknown) =>
  getAxiosErrorMessage(error as AxiosError) || getUnknownErrorMessage(error);

const handleApiError = (error: unknown, endpointName: string) => {
  const statusCode = getStatusCode(error);
  const message = getErrorMessage(error);

  if (message) {
    Logger.error(JSON.stringify({ level: 'error', statusCode, endpointName, message }));
  }

  const { displayCode, displayMessage } = getDisplayError(SERVER_ERROR_CODE);

  return {
    statusCode,
    apiError: new ApiError(
      error instanceof Error ? error.message : String(error),
      statusCode,
      displayCode,
      displayMessage || '',
    ),
  };
};

export default handleApiError;
